import { jsxs, jsx } from 'react/jsx-runtime';
import { useQueryUserInfo } from '../../../user/queries/useQueryUserInfo.js';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { Flex } from '@fabric-app/ui/components/Flex';
import { P, SPAN } from '@fabric-app/ui/components/Typography';
import { BadgePermissionRole } from '../../../permission/components/BadgePermissionRole.js';
import { Button } from '@fabric-app/ui/components/Button';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { mediaNotMobile } from '@fabric-app/ui/constants/styled-utils';
import Tooltip from '@fabric-app/ui/components/Tooltip';
import { styled } from 'styled-components';
import AvatarUser from '../../../user/components/AvatarUser/AvatarUser.js';

const DropdownMemberItem = ({ member, anonId, following, spotlightSelf, followUser, itemType, membersOnlineCount }) => {
  const { data: user } = useQueryUserInfo();
  const { isMobileView } = useResponsive();
  const isSelf = member.id === user?.id || member.id === anonId;
  const followActive = following === member.id;
  const spotlightDisabled = membersOnlineCount < 2;
  return /* @__PURE__ */ jsxs(Item, {
    as: Flex,
    alignItems: "center",
    gap: "elementsContainer",
    overflow: "hidden",
    children: [
      /* @__PURE__ */ jsxs(Flex, {
        gap: 12,
        alignItems: "center",
        overflow: "hidden",
        children: [
          /* @__PURE__ */ jsx(AvatarUser, {
            user: member,
            size: 32,
            state: !member.online ? "offline" : void 0,
            allowTooltipHover: false
          }),
          /* @__PURE__ */ jsxs(Flex, {
            gap: "element",
            alignItems: "center",
            children: [
              /* @__PURE__ */ jsxs(Flex, {
                alignItems: "center",
                overflow: "hidden",
                style: {
                  gap: 3
                },
                children: [
                  /* @__PURE__ */ jsx(P, {
                    ellipsis: true,
                    size: "sm",
                    weight: 500,
                    color: member.online ? "primary" : "quaternary",
                    children: member.name
                  }),
                  isSelf && /* @__PURE__ */ jsx(SPAN, {
                    color: "quaternary",
                    size: "sm",
                    weight: 500,
                    style: {
                      flexShrink: 0
                    },
                    children: "(you)"
                  })
                ]
              }),
              /* @__PURE__ */ jsx(BadgePermissionRole, {
                tooltipDescriptionForCurrentUser: isSelf,
                itemType,
                role: member.role,
                size: "sm",
                style: member.online ? {
                  opacity: 0.7
                } : {
                  opacity: 0.35
                }
              })
            ]
          })
        ]
      }),
      member.online && spotlightSelf && followUser && (isSelf ? /* @__PURE__ */ jsx(Tooltip, {
        label: spotlightDisabled ? "No one else is here" : "Make everyone follow you",
        allowTooltipHover: false,
        delay: 0,
        children: /* @__PURE__ */ jsx(Button, {
          variant: isMobileView ? "bg-tertiary" : "bg-secondary",
          size: "sm",
          onClick: (e) => spotlightSelf(e),
          style: {
            marginLeft: "auto",
            fontWeight: 500
          },
          disabled: spotlightDisabled,
          children: "Spotlight me"
        })
      }) : /* @__PURE__ */ jsx(Button, {
        variant: followActive ? "danger-transparent" : isMobileView ? "bg-tertiary" : "bg-secondary",
        size: "sm",
        onClick: (e) => followUser(member.id, e),
        style: {
          marginLeft: "auto",
          fontWeight: 500
        },
        children: followActive ? "Stop following" : "Follow"
      }))
    ]
  });
};
const Item = styled(DropdownMenu.Item).withConfig({
  displayName: "DropdownMemberItem__Item",
  componentId: "sc-a7176fbe-0"
})([
  `&:hover{background:inherit !important;cursor:default;}height:46px;`,
  `{padding:0 0.5rem;}`
], mediaNotMobile);

export { DropdownMemberItem as default };
//# sourceMappingURL=DropdownMemberItem.js.map
